<template>
  <b-overlay :show="show_overlay">
    <div class="app">
      <!-- Modal Component -->
      <b-modal id="modalPrevent" ref="modal" title="Cambiar contraseña" hide-footer class="modal-primary">
        <!-- <b-form @submit="onSubmit"> -->
        <b-form @submit.prevent="onSubmit">
          <b-form-group id="exampleInputGroup1" label="Contraseña Actual:" label-for="" description="">
            <b-form-input id="" type="password" v-model="contrasenaactual" required placeholder=""> </b-form-input>
          </b-form-group>

          <b-form-group id="exampleInputGroup1" label="Contraseña:" label-for="" description="">
            <b-form-input id="" type="password" v-model="contrasena1" required placeholder=""> </b-form-input>
          </b-form-group>

          <b-form-group id="exampleInputGroup1" label="Repita Contraseña:" label-for="" description="">
            <b-form-input id="" type="password" v-model="contrasena2" required placeholder=""> </b-form-input>
          </b-form-group>

          <button class="btn btn-primary">Enviar</button>
        </b-form>
      </b-modal>

      <print-pallet> </print-pallet>

      <b-navbar toggleable="lg" type="dark" variant="dark">
        <!-- <b-img src="/img/santa-hat.png" class="santa-hat" width="48"></b-img> -->
        <b-navbar-brand href="#" class="logo-font" to="/">
          <!-- <b-img
            style="background-color: #fff"
            blank-color="#bbb"
            width="15px"
            height="15px"
            src="img/avatars/packapp_logo_sm.png"
            fluid
          ></b-img> -->
          PACKAPP</b-navbar-brand
        >

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <transition name="slide">
          <b-collapse id="nav-collapse" is-nav v-if="ready">
            <b-navbar-nav v-for="(mod, idx) in menu" :key="idx">
              <b-nav-item-dropdown :text="mod.label">
                <template v-for="(child, idx2) in mod.children">
                  <b-dropdown-item :key="idx2" :to="child.path">{{ child.label }} </b-dropdown-item>
                </template>
              </b-nav-item-dropdown>
            </b-navbar-nav>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <DefaultHeaderDropdownAccnt />
            </b-navbar-nav>
          </b-collapse>
        </transition>
      </b-navbar>

      <div class="app-body">
        <!--      <AppSidebar fixed>-->
        <!--        <SidebarHeader />-->
        <!--        <SidebarForm />-->
        <!--                <SidebarNav :navItems="nav"></SidebarNav>-->
        <!--        <SidebarFooter />-->
        <!--        <SidebarMinimizer />-->
        <!--      </AppSidebar>-->
        <main class="main">
          <!--        <Breadcrumb :list="list" />-->
          <div class="container-fluid">
            <router-view></router-view>
          </div>
        </main>
        <AppAside fixed>
          <DefaultAside />
        </AppAside>
      </div>
      <TheFooter>
        <!--footer-->
        <div>
          <a href="https://packapp.cl">Packapp</a>
          <span class="ml-1">&copy; 2021 Pecco Systems</span>
        </div>
        <div class="ml-auto">
          <span class="mr-1">Powered by</span>
          <a mailto="jplattus@peccosystems.com">Pecco Systems</a>
        </div>
      </TheFooter>
    </div>
  </b-overlay>
</template>

<script>
/*import nav from '@/_nav'*/
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb
} from "@coreui/vue";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdown from "./DefaultHeaderDropdown";
import DefaultHeaderDropdownNotif from "./DefaultHeaderDropdownNotif";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
import DefaultHeaderDropdownMssgs from "./DefaultHeaderDropdownMssgs";
import DefaultHeaderDropdownTasks from "./DefaultHeaderDropdownTasks";
import PrintPallet from "../views/printComponent/printPallet.vue";
import { mapState } from "vuex";

export default {
  name: "DefaultContainer",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdown,
    DefaultHeaderDropdownMssgs,
    DefaultHeaderDropdownNotif,
    DefaultHeaderDropdownTasks,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    PrintPallet
  },
  data() {
    return {
      menu: [],
      nav: [],
      ready: false,
      contrasenaactual: "",
      contrasena1: "",
      contrasena2: ""
    };
  },
  computed: {
    ...mapState(["user", "show_overlay"]),
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter((route) => route.name || route.meta.label);
    },
    baseUrlAdmin() {
      return localStorage.getItem("packapp_api_url") + "/admin/";
    }
  },
  methods: {
    goTrazavilidad() {
      this.$router.push("/trazabilidad/search");
    },
    onSubmit() {
      if (this.contrasena1 == "" || this.contrasena2 == "") {
        this.$swal.fire("Falta llenar datos en el formulario", "", "warning");
      } else {
        if (this.contrasena1 != this.contrasena2) {
          this.$swal.fire("Las contraseñas deben ser iguales", "", "warning");
        } else {
          const Data = {
            new_password: this.contrasena1,
            old_password: this.contrasenaactual
          };

          let padre = this;

          this.$axios
            .put("/menu/password/change/", Data)
            .then((res) => {
              padre.$refs.modal.hide();

              padre.$swal.fire("Contraseña actualizada con éxito", "", "success");

              this.contrasena1 = "";
              this.contrasena2 = "";
              this.contrasenaactual = "";
            })
            .catch(function (error) {
              padre.$swal.fire(error.response.data.detail, "", "error");

              //console.log(error.response.data.detail);
            });
        }
      }
    },
    renderMenu() {
      const routes = this.$router.options.routes;
      this.menu = routes[0].children
        .filter((item) => item.children && item.meta && item.meta.show !== false && this.user.scope.includes(item.name))
        .map((item) => {
          return {
            name: item.name,
            label: item.meta && item.meta.label ? item.meta.label : item.name,
            path: item.path,
            children: item.children
              ? item.children
                  .filter((child) => child.meta && child.meta.show !== false && this.user.scope.includes(child.name))
                  .map((child) => {
                    return {
                      name: child.name,
                      path: child.path,
                      label: child.meta && child.meta.label ? child.meta.label : child.name
                    };
                  })
              : null
          };
        });
    }
  },
  mounted() {
    setTimeout(() => {
      this.renderMenu();
      this.$nextTick(() => {
        this.ready = true;
      });
    }, 500);
  }
};
</script>
<style>
.santa-hat {
  transform: rotate(-40deg);
  margin-top: -10px;
}

.dropdown-item {
  padding: 5px 20px;
}
@import url("https://fonts.googleapis.com/css2?family=Orbitron:wght@800&display=swap");
.logo-font {
  font-family: "Orbitron", sans-serif;
  font-size: 16px;
  transform: scale(1, 0.95);
  -webkit-transform: scale(1, 0.95); /* Safari and Chrome */
  -moz-transform: scale(1, 0.95); /* Firefox */
  -ms-transform: scale(1, 0.95); /* IE 9+ */
  -o-transform: scale(1, 0.95); /* Opera */
}
.slide-leave-active,
.slide-enter-active {
  transition: 0.3s;
}
.slide-enter {
  transform: translate(0, -100%);
}
.slide-leave-to {
  transform: translate(0, 100%);
}

.img-slider {
  overflow: hidden;
  position: relative;
  height: 200px;
  width: 400px;
}

.img-slider img {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
</style>
